// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___PiBa0","title":"title___33qAd","body":"body___3OeMa"};